export const eosPermissions = {
  viewAndEditMappingConfiguration: 'ViewAndEditMappingConfiguration',
  viewForecast: 'ViewForecast',
  adjustRiskForecast: 'AdjustRiskForecast',
  approveRejectForecast: 'ApproveRejectForecast',
  uploadForecast: 'UploadForecast',
  viewAuditLog: 'ViewAuditLog',
  viewRolesAndManagement: 'ViewRolesAndManagement',
} as const;
